import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, fields } from '../../../../src/helpers/LinkMapper';

const fieldSchema = {
    "requestId": [ fields.number ],
    "compensationAmount": [ fields.number ]
};

export default class WhitelistClaimDetails extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(WhitelistClaimDetails, json, getResolvers(fieldSchema));
    }
}
